<script>
  import Select from 'svelte-select';

  export let export_weekly_excel;
  export let u_n;
  export let year_buttons;
  export let salesteams_all;
  export let mein_name;
  export let origin_all_sales_members;
  export let ghais_special_access;
  export let individual_rights;

  export let group_rights = false;

  let from_week = { value: 1, label: 1 };
  let to_week = { value: calc_weeknumber(), label: calc_weeknumber() };

  let from_month = { value: 1, label: 1 };
  let to_month = { value: 12, label: 12 };

  const items = weeks();

  let group_by_team = true;
  let year_filter = '2024';

  on: change = {};

  let monthly_checked = false;

  function toggleMyValue() {
    group_by_team = !group_by_team;
    console.log('group_by_team: ', group_by_team);
  }

  function set_year_filter(year) {
    year_filter = year;
    console.log('group_rights: ', group_rights);
    console.log('salesteams_all: ', salesteams_all);
  }

  function calc_weeknumber() {
    var currentDate = new Date();
    var startDate = new Date(currentDate.getFullYear(), 0, 1);
    var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));

    var weekNumber = Math.ceil(days / 7);
    return weekNumber;
  }

  function weeks() {
    var week_list = [];
    for (var i = 1; i < 54; i++) {
      week_list.push({ value: i, label: i });
    }
    return week_list;
  }
</script>

<div id="outerdiv" class="col">
  <div class="row"><h4>Year:</h4></div>

  <div class="row">
    <div class="col">
      {#each year_buttons as b}
        <button on:click={() => set_year_filter(b)} class="btn {year_filter === b ? 'active' : ''}">{b}</button>
      {/each}
    </div>
  </div>

  {#if !monthly_checked}
    <div class="row" style="padding-top:20px;"><h4>From calendar week:</h4></div>
    <div class="row"><Select bind:value={from_week} {items} /></div>

    <div class="row" style="padding-top:20px;"><h4>To calendar week:</h4></div>
    <div class="row"><Select bind:value={to_week} {items} /></div>
  {/if}

  {#if monthly_checked}
    <div class="row" style="padding-top:20px;"><h4>From Month:</h4></div>
    <div class="row"><Select bind:value={from_month} items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]} /></div>

    <div class="row" style="padding-top:20px;"><h4>To Month:</h4></div>
    <div class="row"><Select bind:value={to_month} items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]} /></div>
  {/if}

  <div class="row" style="padding-top:20px;"><h4>Export:</h4></div>

  <div class="row" style="padding-top:10px;">
    <div class="col">
      {#if ghais_special_access == false}
        <button
          class="btn btn-primary"
          on:click={export_weekly_excel([mein_name], year_filter, from_week, to_week, from_month, to_month, monthly_checked)}
          >My Report</button
        >
      {/if}

      {#if salesteams_all}
        {#if (group_rights && u_n in group_rights) || ghais_special_access}
          {#if group_rights[u_n].includes('ALL') || ghais_special_access}
            <button
              class="btn btn-primary"
              on:click={export_weekly_excel(
                origin_all_sales_members,
                year_filter,
                from_week,
                to_week,
                from_month,
                to_month,
                monthly_checked,
                true
              )}>ALL</button
            >
          {/if}

          {#each salesteams_all as salesteam}
            <!-- {salesteam['teamname']} -->
            {#if group_rights[u_n].includes(salesteam['teamname']) || ghais_special_access}
              <button
                class="btn btn-primary"
                on:click={export_weekly_excel(salesteam['members'], year_filter, from_week, to_week, from_month, to_month, monthly_checked)}
                >{salesteam['teamname']}</button
              >
            {/if}
          {/each}
        {/if}
      {/if}

      {#if individual_rights}
        {#each individual_rights as ir}
          <button
            class="btn btn-primary"
            on:click={export_weekly_excel([ir], year_filter, from_week, to_week, from_month, to_month, monthly_checked)}>{ir}</button
          >
        {/each}
      {/if}
    </div>
  </div>

  <div class="row">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        style="width:9px; height:9px; margin-top:9px; "
        bind:checked={monthly_checked}
        value=""
        id="flexCheckDefault49043439"
      />
      <label class="form-check-label" style="white-space: nowrap; font-size:16px;" for="flexCheckDefault49043439']}">
        <h4>Monthly</h4>
      </label>
    </div>
  </div>
</div>

<style>
  #outerdiv {
    height: 500px;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }
</style>
